var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Hide Password/10x10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Hide-Password/10x10",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 2.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,2.2371 C4.346,2.2371 3.816,2.7671 3.816,3.4211 C3.816,4.0751 4.346,4.6051 5,4.6051 C5.654,4.6051 6.184,4.0751 6.184,3.4211 C6.184,2.7671 5.654,2.2371 5,2.2371",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,5.395 C3.91,5.395 3.026,4.511 3.026,3.421 C3.026,2.331 3.91,1.448 5,1.448 C6.09,1.448 6.974,2.331 6.974,3.421 C6.974,4.511 6.09,5.395 5,5.395 M9.581,2.334 C9.323,1.963 8.957,1.582 8.51,1.239 C7.617,0.554 6.378,0 5,0 C3.622,0 2.383,0.554 1.49,1.239 C1.043,1.582 0.677,1.963 0.419,2.334 C0.167,2.698 0,3.08 0,3.421 C0,3.763 0.167,4.145 0.419,4.509 C0.677,4.88 1.043,5.261 1.49,5.604 C2.383,6.289 3.622,6.842 5,6.842 C6.378,6.842 7.617,6.289 8.51,5.604 C8.957,5.261 9.323,4.88 9.581,4.509 C9.833,4.145 10,3.763 10,3.421 C10,3.08 9.833,2.698 9.581,2.334",
    id: "Fill-11"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password_show.ff934d902f1660a3e56f0f223af069e2.svg";
export { ForwardRef as ReactComponent };